import { connect } from 'react-redux';
import PlanningBoardToolbar from '../components/planning-board-toolbar';

const mapStateToProps = state => ({
  menuVisible: state.header.menuVisible,
  isLoadingBoardData: state.gantt.isLoadingBoardData,
  activeFilters: state.gantt.activeFilters,
  filters: state.gantt.filterDefinitions,
  boardData: state.gantt.boardData,
});

export default connect(mapStateToProps)(PlanningBoardToolbar);
